export const SBAT_GROUP_FILTER_LABELS = {
  primaryInstructors: 'Primary instructors',
  secondaryInstructors: 'Secondary instructors',
  academyModules: 'Modules',
  academyTopics: 'Topics',
  superBatches: 'Batches',
  fromDate: 'From date',
  toDate: 'To date',
};
